import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Button from "../common/Button";
import getfile from "../../utils/getFile";
import { useLiffProfile } from "../../context/LiffProfileContext";

import { ItemHelper } from "../helpers/item-helper";

const UserBcCouponCard = ({
  value,
  clickable = false,
  showButton = false,
  onClick,
  onUseCoupon,
}) => {
  const [thumbnail, setThumbnail] = useState(null);
  const { t, i18n } = useTranslation();
  const { authToken, userId } = useLiffProfile();

  const lang = i18n.language.toUpperCase(); // Replace with your language logic

  const [seniorLayout, setSeniorLayout] = useState(() => {
    const savedLayout = localStorage.getItem("seniorLayout");
    return savedLayout === "true"; // ถ้าได้ "true" (string) ก็คืน true, ถ้าไม่มีหรือไม่ตรงก็ false
  });

  useEffect(() => {
    if (value.thumbnail) {
      // Assuming you have a method to fetch the thumbnail
      fetchThumbnail(value.thumbnail).then((thumbnailUrl) =>
        setThumbnail(thumbnailUrl)
      );
    }
  }, [value.thumbnail]);

  const fetchThumbnail = async (thumbnail) => {
    // Your method to fetch the thumbnail image
    const thumbnailUrl =  await getfile(thumbnail, authToken, userId);
    //console.log(thumbnailUrl);
    return thumbnailUrl;
  };

  const active = value.couponStatus === "I";
  const couponName = ItemHelper.getName(value, lang);
  const couponTag = ItemHelper.getTag(value, lang);
  const statusText =
    value.couponStatus === "U"
      ? "used"
      : value.couponStatus === "E"
      ? "expired"
      : "";

  const formatDate = (date) => {
    let locale = "th-TH";
    if (lang === "EN") {
      locale = "en-EN";
    }
    if (!date) return "";
    return `${t("expired")} : ${new Intl.DateTimeFormat(locale, {
      day: "2-digit",
      month: "short",
      year: "numeric",
    }).format(new Date(date))}`;
  };

  const handleClick = (event) => {
    if (clickable) {
      onClick(value.id);
    } else {
      event.preventDefault();
    }
  };

  const handleUseCoupon = () => {
    onUseCoupon(value.id);
  };

  return (
    <div
      className={`w-full h-full bg-white border border-overlay-12 rounded-2xl p-2 ${
        clickable && active ? "cursor-pointer" : ""
      } ${active ? "" : "text-gray-500"} ${
        seniorLayout ? "flex gap-2.5" : "flex gap-3 sm:gap-1"
      }`}
      onClick={handleClick}
    >
      <div
        className={`relative ${
          seniorLayout ? "basis-36 flex flex-col gap-1" : "w-[30%]"
        }`}
      >
        <div
          className="w-full relative flex justify-center items-center"
          style={{ aspectRatio: "1/1" }}
        >
          <div
            className={`relative rounded-xl overflow-hidden ${
              seniorLayout ? "basis-36" : "w-28 h-28"
            }`}
          >
            {thumbnail && (
              <img
                src={thumbnail}
                className="object-contain w-full h-full relative z-20"
                onError={(event) => event.target.classList.add("hidden")}
              />
            )}
            <div
              className={`w-full h-full absolute top-0 ${
                active ? "z-10 bg-overlay-5" : "z-30 bg-overlay"
              }`}
            />
          </div>
          {!active && (
            <span className="w-full absolute z-40 bg-overlay text-secondary-text-invert rounded-xl text-center py-1">
              {t(statusText)}
            </span>
          )}
        </div>
        {/*seniorLayout && (
          <div className="text-xs font-normal text-secondary-text-gray self-center">
            {`${formatDate(value.expireDate)}`}
          </div>
        )*/}
      </div>
      <div
        className={`flex flex-col mx-1 gap-y-1 ${
          seniorLayout ? "basis-60" : "w-full"
        }`}
      >
        <div
          className={`font-semibold text-left ${
            seniorLayout ? "text-lg line-clamp-2" : "text-base line-clamp-2"
          }`}
        >
          {couponName}
        </div>
        <div
          className={`font-normal break-words  text-left ${
            seniorLayout ? "text-base line-clamp-3" : "text-sm line-clamp-2"
          }`}
          dangerouslySetInnerHTML={{ __html: couponTag }}
        />
        <div
          className={`w-full flex items-end gap-1 mt-auto ${
            seniorLayout ? "justify-end" : "justify-between"
          }`}
        >
          {!seniorLayout && (
            <div className="text-xs font-normal text-secondary-text-gray">
              {`${formatDate(value.expireDate)}`}
            </div>
          )}
          {showButton && active && (
            <Button
              className="w-30 h-9 text-base sm:text-sm font-semibold"
              type="danger"
              shape="coupon"
              onClick={handleUseCoupon}
            >
              {t("use_coupon")}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default UserBcCouponCard;
